import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';
import api from '../utils/api';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const { user } = useAuth();
  const [socket, setSocket] = useState(null);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!user) {
      if (socket) {
        socket.disconnect();
        setSocket(null);
      }
      return;
    }

    const token = localStorage.getItem('token');
    const s = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:5001', {
      auth: { token },
      transports: ['websocket', 'polling'],
    });

    s.on('connect', () => console.log('Socket connected'));
    s.on('disconnect', () => console.log('Socket disconnected'));
    s.on('notification', (notification) => {
      setNotifications(prev => [notification, ...prev]);
    });

    setSocket(s);

    return () => {
      s.disconnect();
    };
  }, [user]);

  const clearNotifications = () => setNotifications([]);

  // Mark all in-memory + DB new_message notifications for a conversation as read.
  // Removing from the notifications array triggers Navbar's useEffect to re-fetch counts.
  const clearConversationNotifications = async (conversationId) => {
    if (!conversationId) return;
    try {
      await api.put('/notifications/read-conversation', { conversation_id: conversationId });
    } catch {}
    setNotifications(prev =>
      prev.filter(n => !(n.type === 'new_message' && n.data?.conversation_id === conversationId))
    );
  };

  return (
    <SocketContext.Provider value={{ socket, notifications, clearNotifications, clearConversationNotifications }}>
      {children}
    </SocketContext.Provider>
  );
}

export const useSocket = () => useContext(SocketContext);
